import { render, staticRenderFns } from "./eod-events-drawer-collapse.vue?vue&type=template&id=2bec4390"
import script from "./eod-events-drawer-collapse.vue?vue&type=script&lang=js"
export * from "./eod-events-drawer-collapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports